import { gql } from '@apollo/client';

import {
  WITH_COUNT_VARIABLES,
  WITH_COUNT_ARGUMENTS
} from '../../queries/withCount';

const ERRORS = `errors { path, message }`;

const CORRESPONDENCE_FIELDS = `
  id
  asset {
    id
    name
    vin
    seller { id, name }
    webPath
  }
  buyer { id, name }
  userLog {
    id
    user { firstName, lastName }
  }
  action
  createdAt
  recipientList
`;



export const RESEND_CORRESPONDENCE = gql`
  mutation ResendCorrespondence($id: ID!) {
    resendCorrespondence(id: $id) {
      correspondence { id, action }
      ${ERRORS}
    }
  }
`;

export const CORRESPONDENCE_WITH_COUNT = gql`
  query (
    $resourceType: String
    $resourceId: ID
    ${WITH_COUNT_VARIABLES}
  ) {
    correspondenceWithCount(
      resourceType: $resourceType
      resourceId: $resourceId
      ${WITH_COUNT_ARGUMENTS}
    ) {
      entries {
        ${CORRESPONDENCE_FIELDS}
      }
      count
    }
  }
`;

